<template>
  <portal to="modal" :disabled="inline">
    <transition name="modal" appear>
      <div
        class="modal-mask"
        :class="{ menu, inline }"
        @touchmove="stopScroll"
        @mousedown.self="isSelfClick = true"
        @mouseup.self="onClick"
        @mouseup="isSelfClick = false"
        @touchstart.self="isSelfClick = true"
        @touchend.self="onClick"
        @touchend="isSelfClick = false"
      >
        <slot />
      </div>
    </transition>
  </portal>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

/**
 * モーダル背景
 */
export default {
  name: 'ModalMask',
  props: {
    /** メニュー表示 */
    menu: { type: Boolean, default: false },
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: { type: Boolean, default: false },
  },
  data() {
    return {
      isSelfClick: false,
    }
  },
  methods: {
    onClick() {
      if (!this.isSelfClick) return
      /**
       * 背景自体のクリック
       * @event
       */
      this.$emit('click')
    },
    stopScroll(e) {
      if (!e.target.closest('.modal-main')) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.modal-mask {
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  /* TODO z-index を整理したら消す */
  z-index: 2000;

  .responsive & {
    position: fixed;
  }
}

.menu {
  justify-content: flex-start;
  position: fixed;
}

.inline {
  height: 480px;
  position: static;
  width: auto;
}

/* 以下 transition 用 */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
